// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1dNrT","large":"styles_large__1Sa43"};